import React, { useEffect } from "react";
import Modal from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { useRecoilValue } from "recoil";
import { getRecoil, resetRecoil } from "recoil-nexus";
import LogController from "../../controller/LogController";
import { useToast } from "../../controller/ToastController";
import FindItem from "../../event/FindItem/FindItem";
import RandomBoxNewYear from "../../event/RandomBoxNewYear/RandomBoxNewYear";
import RandomBoxXmas from "../../event/RandomBoxXmas/RandomBoxXmas";
import { eventState, EventStateType } from "../../recoil/event";
import { langState, langText } from "../../recoil/lang";
import "../../styles/CustomModal.css";
import RouletteEvent from "../../event/Roulette/roulette";
import RegionCluster from "../../event/regionCluster/regionCluster";

const SurpriseModal = (oProps: { event: EventStateType }) => {
  const showToast = useToast();
  const lang = useRecoilValue<number>(langState);

  const onCloseModal = () => {
    resetRecoil(eventState);
  };

  useEffect(() => {
    if (oProps.event.visible && oProps.event.used > 0) {
      showToast(langText.coupon_already[lang], "error");

      LogController.click({
        path: "EventSlider",
        params: "event",
        params2: "이미 쿠폰을 발급하여 이벤트 진행불가",
        index: oProps.event.event_id!,
      });

      resetRecoil(eventState);
    }
  }, [oProps.event.visible]);

  const getEvent = () => {
    const game = getRecoil(eventState).event_name;
    const eventType = getRecoil(eventState).event_type;
    if (game === "선물상자") return <RandomBoxXmas />;
    else if (game === "복주머니") return <RandomBoxNewYear />;
    else if (game === "틀린그림찾기") return <FindItem />;
    else if (game === "룰렛") return <RouletteEvent />;
    else {
      if (eventType === 3) {
        return <RegionCluster />;
      }
    }
  };

  return (
    <Modal
      open={oProps.event.visible}
      onClose={onCloseModal}
      center
      classNames={{
        overlay: "surpriseModalOverlay",
        modal: "eventGameModal",
      }}
      closeOnOverlayClick={true}
      showCloseIcon={getRecoil(eventState).event_type !== 3}
      closeIcon={
        <img
          src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close.svg`}
          style={{ zIndex: 10, padding: "40px", paddingTop: "50px" }}
          alt="닫기 아이콘"
        />
      }
      animationDuration={150}
    >
      {/* <SnowBackground /> */}

      {getEvent()}
      {/* <RockPaperScissors /> */}
    </Modal>
  );
};

export default SurpriseModal;
